/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Password_Not_VariedInputs */

const fr_error_password_not_varied = /** @type {(inputs: Error_Password_Not_VariedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce mot de passe est trop facile à deviner. Essayez une phrase moins prévisible.`)
};

const en_error_password_not_varied = /** @type {(inputs: Error_Password_Not_VariedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That password is too easy to guess. Try a less predictable sentence.`)
};

/**
* | output |
* | --- |
* | "That password is too easy to guess. Try a less predictable sentence." |
*
* @param {Error_Password_Not_VariedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_password_not_varied = /** @type {((inputs?: Error_Password_Not_VariedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Password_Not_VariedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_password_not_varied(inputs)
	return fr_error_password_not_varied(inputs)
});